"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitles = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../const");

var _headerTitles = require("./header-titles.styled");

var _contentUi = _interopRequireDefault(require("../content/content-ui"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderTitles = function HeaderTitles(_ref) {
  var headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      description = _ref.description,
      headline1Color = _ref.headline1Color,
      headline2Color = _ref.headline2Color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      descriptionAlign = _ref.descriptionAlign,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      noGutters = _ref.noGutters,
      _ref$mb = _ref.mb,
      mb = _ref$mb === void 0 ? 0 : _ref$mb;

  var getJustifyContent = function getJustifyContent() {
    switch (align) {
      case 'left':
        return 'flex-start';

      case 'right':
        return 'flex-end';

      default:
        return 'center';
    }
  };

  var alignPadding = align === 'center' ? [0, 24] : [0];
  var padding = noGutters ? [0] : alignPadding;
  return /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    p: padding,
    mb: mb,
    "data-test": _const.TestType.BLOCK,
    "data-test-id": _const.TestValue.AEM_HEADER_TITLES
  }, headline1 && /*#__PURE__*/_react.default.createElement(_headerTitles.OverlineStyled, {
    as: "h2",
    color: headline1Color,
    align: align
  }, headline1), headline2 && /*#__PURE__*/_react.default.createElement(_headerTitles.HeadlineStyled, {
    as: "h3",
    color: headline2Color,
    align: align
  }, headline2), description && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    display: "flex",
    justifyContent: getJustifyContent()
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.DescriptionStyled, {
    as: "div",
    color: headline2Color,
    fullWidth: fullWidth
  }, /*#__PURE__*/_react.default.createElement(_contentUi.default, {
    align: descriptionAlign || align
  }, description))));
};

exports.HeaderTitles = HeaderTitles;